<template>
<pop-up-layout 
  :title="$t('promociones.borrarDocumento')"
  :aceptar="$t('general.misc.eliminar')"
  :saving="waitingForLoad"
  @volver="$parent.hide()"
  @aceptar="eliminar()"
>
  <v-layout column justify-center align-center>
    <o-description-title class="text-xs-center" style="margin-top: 10px">
      {{$t('promociones.textoBorrar', {nombre: nombre !== null && nombre !== ''? nombre : indice})}}
    </o-description-title>
    <img style="margin-top: 30px; margin-bottom: 30px; width:150px; height:150px;" src="~@/assets/images/WARNING_GRIS.png"/>
    <o-description-title>
      {{$t('promociones.confirmacionBorrar')}}
    </o-description-title>
  </v-layout>
</pop-up-layout>
</template>

<script>

export default {
  props: ['nombre', 'indice'],
  data () {
    return {
      waitingForLoad: false
    }
  },
  methods: {
    eliminar () {
      this.$emit('eliminar', true)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/promociones/DocumentoBorrar.vue